module.exports = __webpack_public_path__ + "static/media/dark-submenu-unidades.72df179d.svg";